var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "form-page"
  }, [_c("transition", {
    attrs: {
      name: "formslide"
    }
  }, [_vm.component && _vm.show ? _c("div", {
    staticClass: "design-layout-form"
  }, [_c("h2", {
    staticClass: "form-head"
  }, [_c("svg", {
    staticClass: "slide-container-head-icon",
    attrs: {
      width: "30",
      height: "30",
      "aria-hidden": "true"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("designCategory/formClose");
      }
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#iconfanhuibeifen"
    }
  })]), _c("span", [_vm._v(" 内容设置 ")])]), _c("div", {
    staticClass: "design-form-body"
  }, [_c(_vm.component.type, {
    ref: _vm.component.id,
    tag: "component",
    model: {
      value: _vm.component,
      callback: function callback($$v) {
        _vm.component = $$v;
      },
      expression: "component"
    }
  })], 1)]) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };